import { PlatformEnum } from './platforms.enum';

export const GeoFenceMaxCount = {
    [PlatformEnum.ANDROID]: 100,
    [PlatformEnum.IOS]: 20,
};
